import {
	Component,
	OnInit,
	Input,
	Optional,
	HostBinding,
	OnChanges
} from "@angular/core";
import { CtaButtonGroupControlComponent } from "../cta-button-group-control/cta-button-group-control.component";
import { CtaButtonFeaturesGroupComponent } from "../cta-button-features-group/cta-button-features-group.component";

@Component({
    selector: "dodo-cta-button-features",
    templateUrl: "./cta-button-features.component.html",
    styleUrls: ["./cta-button-features.component.scss"],
    standalone: false
})
export class CtaButtonFeaturesComponent implements OnInit {
	@Input() id: string | number;

	@HostBinding("class.active")
	@Input()
	active = false;

	constructor(
		@Optional()
		private __ctaButtonFeaturesGroup: CtaButtonFeaturesGroupComponent
	) {}

	ngOnInit() {
		if (this.__ctaButtonFeaturesGroup) {
			this.__ctaButtonFeaturesGroup.addFeatures(this);
		}
	}
}
